import React, { useContext } from "react";
import PdfView from "../../common/fileUploads/components/pdfView";
import "../../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import "../../../ui-styles/list/AttachmentList.css";
import "../../../ui-styles/fileView/FileView.css";

const CertificateFileView = (props) => {
    const { data, handleClose } = props;

    const downloadFile = async (data) => {
        const response = await fetch(data.url);
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        const formattedTime = `${hours}:${minutes}`;
        const sender = data.senderName;
        link.style.display = 'none';
        link.href = url;
        link.download = `${sender}_(${formattedDate})(${formattedTime})`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const getFileUrl = (key, url) => {
        return key
            ? `https://${process.env.REACT_APP_s3}.s3.${process.env.REACT_APP_s3Region}.amazonaws.com/${key}`
            : url;
    };

    const getFileExtension = (fileName) => {
        if (!fileName) return null;
        const parts = fileName.split(".");
        return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : null;
    };

    const fileExtension = getFileExtension(data?.fileName);

    const renderFilePreview = () => {
        if (data?.fileType?.startsWith("image")) {
            // Handle image files
            return (
                <div className="mediaFileContainer">
                    <img
                        style={{ width: "100%", height: "100%", objectFit: "contain", overflow: "hidden" }}
                        src={getFileUrl(data.key, data.url)}
                        alt="mediafile"
                    />
                </div>
            );
        } else if (data?.fileType === "application/pdf") {
            // Handle PDF files
            return <PdfView data={data} />;
        } else if (["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(fileExtension)) {
            console.log("inside", fileExtension)
            // Handle MS Office files using react-file-viewer
            return (
                <button style={{color:'#fff', cursor: "pointer"}} className="downloadfile" onClick={() => downloadFile(data)}>
                                        Download File
                                    </button> 
            );
        } else {
            // Fallback for unsupported file types
            return <div>Unsupported file type.</div>;
        }
    };

    return (
        <div className={props.data ? "btmDtlSlider visible" : "btmDtlSlider"}>
            <div className="patfileReportsView">
                <div className="fvHdrCntnr">
                    <div className="fileViewHeader">
                        <div className="fileTxtRow">
                            <span
                                className="ellipsisTxt"
                                style={{ fontSize: "20px", fontWeight: "500", lineHeight: 1.4 }}
                            >
                                {data?.fileName}
                            </span>
                            {data?.comment && data.status !== "approved" && (
                                <>
                                    <span
                                        className="ellipsisTxt"
                                        style={{ fontSize: "14px", fontWeight: "500", lineHeight: 1.4 }}
                                    >
                                        <span style={{ color: "#FD8D8D" }}>{`Comment : `}</span>
                                        {data?.comment}
                                    </span>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="hdrActionGroup" onClick={handleClose}>
                        <div className="hdrActItem close"></div>
                    </div>
                </div>
                <div className="mediaBdyCntnr2">
                    <div className="mediaBdy2">
                        <div className="mediaViewBox alignCenter justifyCenter">
                            {renderFilePreview()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CertificateFileView;
